// redux/authSlice.js
import React from 'react';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { UserLogin, authenticateUser } from '../service/user_service';
import Cookies from 'js-cookie';

// Initial state
const initialState = {
  user: null,
  token: Cookies.get('token') || null,
  loading: false,
  error: null,
};

// Thunk for handling user login
export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (userdata, { rejectWithValue }) => {
    try {
      const token = await UserLogin(userdata);
      Cookies.set('token', token, { expires: 1 });
      const userData = await authenticateUser(token);
      return { token, userData };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      Cookies.remove('token');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.userData;
        state.token = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { logout } = authSlice.actions;
export default authSlice.reducer;
